<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="ibox">
        <div class="ibox-title">
          <Button type="primary" @click="addGroupData('')">添加数据</Button>
          <div class="ibox-tools">

          </div>
        </div>
        <div class="ibox-content">
          <div class="row">
            <div class="col-sm-8 m-b-xs">
              <Form :label-width="80">
                <FormItem label="是否可用:">
                  <Enum :enumJsonKey="'crmdict-isEnable'"  v-model="queryParam.query_EQ_isDelete"
                        @on-change="queryTableDatas" >
                  </Enum>
                </FormItem>
              </Form>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-striped  table-bordered">
              <thead>
              <tr>
                <th class="text-center">编号</th>
                <th class="text-center" v-for="(item,index) in fieldDatas" :key="`head-`+index">{{item.name}}</th>
                <th class="text-center">是否可用</th>
                <th class="text-center">操作</th>
              </tr>
              </thead>
              <tbody v-if="systemGroupData.length > 0">
              <tr v-for="(vo,index) in systemGroupData" :key="vo.id">
                <td class="text-center">
                  {{index+1}}
                </td>
                <td class="text-center" v-for="(item,index) in fieldDatas" :key="`body-`+index">
                  <span v-if="vo.fieldDataPropMap[item.title].type === 'upload'">
                    <img :src="vo.fieldDataPropMap[item.title].value" height="45" width="45"/>
                  </span>
                  <span v-else-if="vo.fieldDataPropMap[item.title].type === 'video'">
                    {{ JSON.parse(vo.fieldDataPropMap[item.title].value).originalUrl }}
                  </span>
                  <span v-else-if="vo.fieldDataPropMap[item.title].type === 'entity'">
                    {{JSON.parse(vo.fieldDataPropMap[item.title].value).name}}
                  </span>
                  <span v-else>
                    {{vo.fieldDataPropMap[item.title].value}}
                  </span>
                </td>
                <td class="text-center">
                  <Icon type="md-checkmark" v-if="vo.isDelete === '0'" color="#027dff"/>
                  <Icon type="md-close" v-if="vo.isDelete === '1'"  color="#ff6a48"/>
                </td>
                <td class="text-center">
                  <Button type="info"  @click="addGroupData(vo.id)"> 编辑</Button>&nbsp;&nbsp;
                  <Button type="warning" @click="deleteGroupData(vo.id)"> 删除</Button>
                </td>
              </tr>
              </tbody>
              <tbody v-if="systemGroupData.length === 0">
              <tr>
                <td :colspan="fieldDatas.length+3">暂时没有数据</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="list-footer-page">
            <p>共{{systemGroupData.length}}项</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Enum from '@/components/paas/query-enum' //枚举查询
    import EnumShow from "@/components/paas/enum-show";  //如果有枚举，需要引入
    export default {
      name: "list",
      components: {Enum,EnumShow},
      data(){
        return {
          serviceUrl:'/eb/system/group/data',
          currentIdFiledName: 'id',
          queryParam:{
            query_EQ_isDelete:'',
            queryOrderBy_: 'sort@asc',
          },
          fieldDatas:[],
          systemGroupData:[],
        }
      },
      created(){
        this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/returnGroupData?key="+this.$route.query.configName).then(res => {
          if (res.code === 200) {
            this.fieldDatas = res.data.fieldDatas;
            this.systemGroupData = res.data.systemGroupData;
          }
        }).catch(function(error){
          this.$Message.error('数据加载失败，请重试！');
        });
      },
      methods:{
        /**
         * 添加数据
         */
        addGroupData(id){
          let url = "/eb/system/group/data/edit?key="+this.$route.query.configName+"&paasCurrentFunctionId="+this.$route.query.paasCurrentFunctionId;
          if(id){
            url += "&id="+id;
          }
          this.$router.push({'path':url});
        },
        deleteGroupData(id){
          let that = this;
          this.$swal({
            title: "您确定要删除这条信息吗",
            text: "删除后将无法恢复，请谨慎操作！",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "是的，我要删除！",
            cancelButtonText: "让我再考虑一下…",
            closeOnConfirm: false,
            closeOnCancel: false
          }).then((isConfirm)=> {
            if(isConfirm.value){
              that.axios.post(that.$store.state.sysApi+"/eb/system/group/data/delete?ids="+id).then((res)=> {
                if (res.code === 200) {
                  if(that.systemGroupData != null && that.systemGroupData.length> 0){
                    for(let i = 0; i < that.systemGroupData.length; i++){
                      if(that.systemGroupData[i].id === id){
                        that.systemGroupData.splice(i,1);
                      }
                    }
                  }
                  that.$Message.success('删除成功!');
                } else {
                  that.$Message.error('清空失败!');
                }
              }).catch((err)=> {
                that.$Message.error(err);
              })
            }
          }).catch(console.log);
        },
        queryTableDatas(){

        }
      }
    }
</script>

<style scoped>
  .ibox{clear:both;margin-bottom:15px;margin-top:0;padding:0}
  .ibox-title{-moz-border-bottom-colors:none;-moz-border-left-colors:none;-moz-border-right-colors:none;-moz-border-top-colors:none;background-color:#fff;border-color:#e7eaec;-webkit-border-image:none;-o-border-image:none;border-image:none;border-style:solid solid none;border-width:4px 0 0;color:inherit;margin-bottom:0;padding:14px 15px 7px;min-height:48px}
  .ibox-content{background-color:#fff;color:inherit;padding:15px 20px 20px;border-color:#e7eaec;-webkit-border-image:none;-o-border-image:none;border-image:none;border-style:solid solid none;border-width:1px 0}
  .text-center{
    text-align: center;
  }
  .table-responsive{
    min-height: .01%;
    overflow: initial;
  }
  .table-responsive table{
    background-color: transparent;
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
    border: 1px solid #EBEBEB;
  }
  .table > thead > tr > th{
    border: 1px solid #e7e7e7;
    border-bottom: 1px solid #DDD;
    line-height: 1.42857;
    padding: 8px;
    vertical-align: middle;
  }
  .table > thead:first-child > tr:first-child > th {
    border-top: 0;
  }
  .table-striped > tbody > tr:nth-of-type(2n+1) {
    background-color: #f9f9f9;
  }
  .table-bordered > tbody > tr > td{
    border: 1px solid #e7e7e7;
  }
  .table > tbody > tr > td{
    border-top: 1px solid #e7eaec;
    line-height: 1.42857;
    padding: 8px;
    vertical-align: middle;
  }
</style>
